function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var InotificationCircleYellow = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "#FEC149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.166 16.668C13.166 17.3123 12.6437 17.8346 11.9993 17.8346C11.355 17.8346 10.8327 17.3123 10.8327 16.668H13.166ZM13.15 7.52819C14.5178 8.00412 15.4993 9.30475 15.4993 10.8346L15.5053 12.5846L16.666 14.918C16.666 15.5623 16.1437 16.0846 15.4993 16.0846H8.49935C8.33144 16.0846 8.16584 16.0455 8.01567 15.9705C7.48141 15.7033 7.26485 15.0537 7.53197 14.5194L8.49935 12.5846V10.8346C8.49935 9.30475 9.48093 8.00412 10.8487 7.52819C10.8382 7.46523 10.8327 7.40057 10.8327 7.33464C10.8327 6.6903 11.355 6.16797 11.9993 6.16797C12.6437 6.16797 13.166 6.6903 13.166 7.33464C13.166 7.40057 13.1605 7.46523 13.15 7.52819Z",
    fill: "white"
  }));
});